import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../common/shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { LocalizationModule } from '../localization/localization.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { TileProductComponent } from './tile-product.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { PricesComponent } from './prices/prices.component';
import { PricesTableComponent } from './prices/prices-table/prices-table.component';
import { MatTableModule } from '@angular/material/table';

const routes: Routes = [
  {
    path: 'tigla-metalica/:id',
    component: TileProductComponent,
  },
  {
    path: 'tigla-metalica/:name/:id',
    component: TileProductComponent,
  },
  {
    path: 'accesoriu/:id',
    component: TileProductComponent,
  },
  {
    path: 'accesoriu/:name/:id',
    component: TileProductComponent,
  },
  {
    path: '',
    component: PricesComponent,
  },
];

@NgModule({
  declarations: [PricesComponent, PricesTableComponent, TileProductComponent],
  imports: [
    CommonModule,
    LocalizationModule,
    RouterModule.forChild(routes),
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatTooltipModule,
    FormsModule,
    NgxGoogleAnalyticsModule,
    MatTableModule,
    NgOptimizedImage,
  ],
})
export class ProductsModule {}
